"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLocalizedGlobalize;

var _useWebChatAPIContext = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useLocalizedGlobalize() {
  return (0, _useWebChatAPIContext.default)().localizedGlobalizeState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VMb2NhbGl6ZWRHbG9iYWxpemUuanMiXSwibmFtZXMiOlsidXNlTG9jYWxpemVkR2xvYmFsaXplIiwibG9jYWxpemVkR2xvYmFsaXplU3RhdGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLHFCQUFULEdBQWlDO0FBQzlDLFNBQU8scUNBQXVCQyx1QkFBOUI7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VMb2NhbGl6ZWRHbG9iYWxpemUoKSB7XG4gIHJldHVybiB1c2VXZWJDaGF0QVBJQ29udGV4dCgpLmxvY2FsaXplZEdsb2JhbGl6ZVN0YXRlO1xufVxuIl19